import types from './types';

const getSupplierList = () => ({
  type: types.GET_SUPPLIER_LIST
});

export default {
  getSupplierList
};
